import React, { useState } from 'react';
import { db } from '../../lib/firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../../contexts/AuthContext';
import { Image, Send, X } from 'lucide-react';
import { resolveAvatar } from '../../constants/sampleImages';

export const CreatePost = () => {
  const [content, setContent] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userProfile } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!content.trim() || !userProfile) return;

    setLoading(true);
    try {
      await addDoc(collection(db, 'posts'), {
        authorId: userProfile.uid,
        authorName: userProfile.displayName,
        authorAvatar: userProfile.photoURL,
        content: content.trim(),
        media: [], // Could add image upload later
        likesCount: 0,
        commentsCount: 0,
        createdAt: serverTimestamp(),
      });
      setContent('');
      setIsExpanded(false);
    } catch (error) {
      console.error('Error creating post:', error);
      alert('Failed to create post. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!userProfile) return null;

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm mb-6 overflow-hidden transition-all duration-300">
      {!isExpanded ? (
        <div className="flex gap-3">
          <div className="w-10 h-10 rounded-full bg-slate-100 overflow-hidden shrink-0">
            <img src={resolveAvatar(userProfile.photoURL)} alt="Me" className="w-full h-full object-cover" />
          </div>
          <button 
            onClick={() => setIsExpanded(true)}
            className="flex-1 text-left px-4 py-2 bg-slate-50 hover:bg-slate-100 rounded-full text-slate-400 text-xs md:text-sm transition-colors flex items-center"
          >
            Share your latest find or gem story...
          </button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
               <div className="w-8 h-8 rounded-full bg-slate-100 overflow-hidden shrink-0">
                  <img src={resolveAvatar(userProfile.photoURL)} alt="Me" className="w-full h-full object-cover" />
               </div>
               <span className="text-xs font-bold text-slate-700">{userProfile.displayName}</span>
            </div>
            <button 
              type="button"
              onClick={() => setIsExpanded(false)}
              className="p-1 hover:bg-slate-100 rounded-full text-slate-400 transition-colors"
            >
              <X size={18} />
            </button>
          </div>
          
          <textarea
            autoFocus
            value={content}
            onChange={(e) => setContent(e.target.value)}
            placeholder="What's happening in the gem world?"
            className="w-full min-h-[120px] p-2 text-slate-800 text-sm md:text-base placeholder:text-slate-300 outline-none resize-none"
          />

          <div className="flex items-center justify-between pt-3 border-t border-slate-50">
            <div className="flex gap-2">
              <button 
                type="button"
                className="p-2 hover:bg-primary/5 rounded-full text-primary transition-colors flex items-center gap-2 text-xs font-bold"
              >
                <Image size={20} />
                <span className="hidden md:inline">Photo</span>
              </button>
            </div>
            <button
              type="submit"
              disabled={loading || !content.trim()}
              className="bg-primary text-white px-6 py-2 rounded-full font-black text-xs md:text-sm shadow-lg shadow-primary/20 hover:scale-105 active:scale-95 disabled:opacity-50 transition-all flex items-center gap-2"
            >
              {loading ? 'Posting...' : 'Post'}
              <Send size={16} />
            </button>
          </div>
        </form>
      )}
    </div>
  );
};
